import React, { Component } from 'react';
import styled from 'styled-components';
import {connect} from 'react-redux';
import { BrowserRouter as Router, browserHistory, Switch, Route, Link } from "react-router-dom";
import { Icon, Image, Menu, Segment, Sidebar } from 'semantic-ui-react'
import Content from '../content'

// import { Menubar, Menubartext, Titlebody, Titletext, Appmain, Unitfull, Unit, Unitsblock, Unittext, UnittextOp } from './small-style';
import { Menubartext, Titlebody, Titletext, Appmain, Unitfull, Unit, Unitsblock, Unittext, UnittextOp } from './small-style';

import Smalldraw from './small-draw'
import ExtraSmalldraw from './extrasmall-draw'


import Menubar from './menubar'
import FormEnter from './form-enter'



class TitleBodySmall extends Component {

  constructor(props){

    super(props)
    this.state={

        unith:null,
        anim:null,
        unitx:null,
        unity:null,
        unit:null,
        paddingtop:null,
        unitfullh: null,
        // winheight: 0,
        // winwidth: 0,
        // extrasmall:false


    }
  }

    handleShowClick = () => {
        console.log('do'+this.state.menudraw);

          this.setState({ menudraw: !this.state.menudraw },
            ()=>console.log('asdasdasd'+this.state.menudraw)

          )


    }
    // handleSidebarHide = () => this.setState({ visible: false })

render (){

    const { loginFormDraw, menudraw,  unitx, unity, anim, messageinputdraw, classvariantbool, unit, unith, paddingtop, unitfullh} = this.state
    const { extrasmall, winwidth, winheight, titleunits} = this.props
    const drawparam = { 'extrasmall':extrasmall,
                        'winwidth':winwidth,
                        'winheight':winheight,
                        'anim':anim,
                        'titleunits':titleunits
                      }
    return (
      <Titlebody>
        <Router >
            <Menubar drawparam={drawparam} callback={this.handleShowClick} loginFormDraw={loginFormDraw} />
                                       <Sidebar style={{'background':'#040445'}}
                                         as={Menu}
                                         animation='overlay'
                                         icon='labeled'
                                         inverted
                                         onHide={this.handleSidebarHide}
                                         vertical
                                         visible={menudraw}
                                         width='200px'
                                       >
                                       <Menu.Item as='a' style={{'color':'#cdc9e7', 'font-weight': 'bold'}}>

                                               <Icon onClick={()=>this.setState({menudraw:false})}  name='long arrow alternate left' />

                                       </Menu.Item>

                                          {titleunits.map((unit)=>
                                            <Link to={'/'+unit.id+'/'} onClick={this.handleShowClick}>
                                                  <Menu.Item as='a' style={{'color':'#f7f6fb', 'font-weight': 'bold'}}>

                                                        {unit.unitname}

                                                  </Menu.Item>
                                            </Link>
                                          )}

                                       </Sidebar>

                                                           <Route path={"/"} render={()=> <div>&nbsp;</div> } />

                                                               <Unitsblock extrasmall={extrasmall}>

                                                                         {/*extrasmall ?
                                                                           <ExtraSmalldraw {...drawparam}/>
                                                                           :
                                                                           <Smalldraw {...drawparam} />
                                                                         */}
                                                                         <Smalldraw {...drawparam} />


                                                               </Unitsblock>




        </Router>

    </Titlebody>
  );
}
}

export default connect(
  state => ({

        titleunits:state.titleunits,

  }),

)(TitleBodySmall);
